import React from 'react';

import { Box as MuiBox, Grid } from '@mui/material';
import { TextFieldBase } from '../../inputs/TextFieldBase';
import { PhoneField as PhoneFieldBase } from '../../inputs/PhoneField';
import { withFormController } from '../../hocs/forms';
import { InputLabelBase } from '../../inputs/InputLabelBase';
import { withShowable } from '../../../console/_global/lib/withShowable';

const TextField = withFormController(TextFieldBase);
const PhoneField = withFormController(PhoneFieldBase);
const Box = withShowable(MuiBox);

const inputProps = {
  style: {
    border: 'none',
  },
};

function useShowableOrgContact(showableQuestions = []) {
  return React.useMemo(() => {
    return {
      SHOW_FIRST_NAME: showableQuestions.includes('contactFirstName'),
      SHOW_LAST_NAME: showableQuestions.includes('contactLastName'),
      SHOW_PHONE: showableQuestions.includes('contactPhone'),
      SHOW_EMAIL: showableQuestions.includes('contactEmail'),
    };
  }, [showableQuestions]);
}

export const AccountOrgContactRenewalFields = ({
  disabled,
  showableQuestions,
}: any) => {
  const { SHOW_FIRST_NAME, SHOW_LAST_NAME, SHOW_PHONE, SHOW_EMAIL } =
    useShowableOrgContact(showableQuestions);

  return (
    <Grid container style={{ padding: '0rem 2.083rem' }} spacing={2}>
        <Grid item md={6}>
          <Box show={SHOW_FIRST_NAME || SHOW_LAST_NAME}>
            <InputLabelBase required>Current Contact Person</InputLabelBase>
            <Box display="flex">
              <Box show={SHOW_FIRST_NAME} paddingRight="1rem" width="50%">
                <TextField
                  name="contactFirstName"
                  inputProps={inputProps}
                  fullWidth
                  placeholder="Policyholder First Name"
                  disabled={disabled}
                />
              </Box>
              <Box show={SHOW_LAST_NAME} width="50%">
                <TextField
                  name="contactLastName"
                  inputProps={inputProps}
                  fullWidth
                  placeholder="Policyholder Last Name"
                  disabled={disabled}
                />
              </Box>
            </Box>
          </Box>
          <Box show={SHOW_EMAIL}>
            <InputLabelBase required>Current Contact Email</InputLabelBase>
            <TextField
              name="contactEmail"
              inputProps={inputProps}
              fullWidth
              placeholder="Policyholder Email"
              disabled={disabled}
            />
          </Box>
        </Grid>
        <Grid item md={6}>
          <Box show={SHOW_PHONE} margintop="1rem">
            <InputLabelBase required>Current Mobile Number</InputLabelBase>
            <PhoneField
              name="contactPhone"
              placeholder="(123) 456-7890"
              disabled={disabled}
              fullWidth
              inputProps={inputProps}
            />
          </Box>
        </Grid>
      </Grid>
  );
};
